import React from "react";
import { useParams } from "react-router";
import { CreateAndEditAccount } from "../../accounts/edit/components/CreateAndEditAccount";

export const DepotEditPage = () => {
  const { depotId } = useParams<"depotId">();

  return <CreateAndEditAccount type="depot" accountId={depotId!} />;
};
